/* WMG Propagator client - talks to the Apps Script webhook. */
(function () {
  'use strict';
  var root = document.getElementById('pgx');
  if (!root) return;
  var HOOK = (root.getAttribute('data-webhook') || '').trim();
  var PASS_KEY = 'wmg_prop_pass';
  var state = { product: null, suggested: null, health: null, mode: 'import', images: [] };

  function $(id) { return document.getElementById(id); }
  function show(el, on) { el.classList[on ? 'remove' : 'add']('pgx-hide'); }
  function status(el, msg, cls) { el.textContent = msg || ''; el.className = 'pgx-status' + (cls ? ' ' + cls : ''); }
  var paneShown = { import: false, wheels: false, 'new': false, incoming: false, listings: false, setup: false };
  function setPane(name) {
    Array.prototype.forEach.call(document.querySelectorAll('#pgx-tabs button'), function (b) {
      b.classList.toggle('on', b.getAttribute('data-tab') === name);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-pane]'), function (el) {
      var mine = el.getAttribute('data-pane') === name;
      if (!mine) { el.classList.add('pgx-hide'); return; }
      var stepGated = el.id === 'pgx-editor' || el.id === 'pgx-previewcard' || el.id === 'pgx-sender';
      if (stepGated && !state.product) return;
      el.classList.remove('pgx-hide');
    });
    if (name === 'listings') loadListings();
    paneShown[name] = true;
  }
  Array.prototype.forEach.call(document.querySelectorAll('#pgx-tabs button'), function (b) {
    b.addEventListener('click', function () { setPane(b.getAttribute('data-tab')); });
  });

  function guessType(p) {
    var hay = ((p.title || '') + ' ' + (p.category || '') + ' ' + Object.keys(p.specifications || {}).join(' ')).toLowerCase();
    if (/wheel|rim|\u30db\u30a4\u30fc\u30eb/.test(hay)) return 'Wheels';
    if (/coilover|suspension|spring|shock|\u8eca\u9ad8/.test(hay)) return 'Suspension';
    if (/bumper|lip|spoiler|wing|aero|diffuser|fender/.test(hay)) return 'Aero';
    if (/seat|wheel|shift|gauge|interior/.test(hay)) return 'Interior';
    if (/exhaust|manifold|turbo|intake|intercooler/.test(hay)) return 'Engine';
    return 'Parts';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }

  function postJson(payload, attempt) {
    attempt = attempt || 1;
    return fetch(HOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      redirect: 'follow',
      cache: 'no-store'
    }).then(function (r) {
      return r.text().then(function (text) {
        var t = String(text || '').trim();
        try { return JSON.parse(t); } catch (e) {}
        // Google occasionally answers the first request after a deploy or an idle spell with an HTML page
        // (sign in, "temporarily unavailable", a script error page). Give it one quiet retry before complaining.
        if (attempt < 3) {
          return new Promise(function (res) { setTimeout(res, 900 * attempt); }).then(function () { return postJson(payload, attempt + 1); });
        }
        var hint = /accounts\.google|sign in/i.test(t) ? 'The web app is not deployed with access set to Anyone. Redeploy it: Deploy, Manage deployments, pencil, Who has access: Anyone.'
          : /script function not found|doPost/i.test(t) ? 'The sheet script has no doPost. Paste the whole Code.gs into the Apps Script editor, save, and deploy a New version.'
          : /<title>([^<]*)<\/title>/i.test(t) ? 'Google answered with a page titled "' + (t.match(/<title>([^<]*)<\/title>/i) || [])[1] + '" instead of data. Redeploy the script as a New version and try again.'
          : 'Got something that is not JSON back from the script: ' + t.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').slice(0, 140);
        throw new Error(hint);
      });
    });
  }
  function api(action, body) {
    if (!HOOK) return Promise.reject(new Error('No webhook URL set. Paste the Apps Script /exec URL into the theme Google Sheets setting.'));
    var payload = Object.assign({ action: action, passcode: sessionStorage.getItem(PASS_KEY) || '' }, body || {});
    return postJson(payload).catch(function (err) {
      // "Failed to fetch" is the browser refusing before the script runs: say which of the usual causes it is
      if (!(err instanceof TypeError)) throw err;
      var hookShort = HOOK.replace(/^https?:\/\//, '').slice(0, 42) + '\u2026';
      if (!/^https:\/\/script\.google\.com\/macros\/s\/[^/]+\/exec$/.test(HOOK.trim())) {
        throw new Error('The webhook address in Theme settings (' + hookShort + ') is not an Apps Script /exec address. It must look like https://script.google.com/macros/s/.../exec, copied from Deploy, Manage deployments.');
      }
      return fetch(HOOK, { method: 'GET', redirect: 'follow' }).then(function (r) { return r.text(); }).then(function (t) {
        var j = null; try { j = JSON.parse(t); } catch (e) {}
        if (j && j.engine) throw new Error('The script answers to a plain visit but refuses the browser\u2019s request: the deployment is probably set to a signed in audience. Deploy, Manage deployments, pencil, Execute as Me, Who has access Anyone, Deploy, then reload this page.');
        throw new Error('The script address returns something that is not the engine (' + String(t).replace(/<[^>]+>/g, ' ').trim().slice(0, 80) + '). Check the /exec address and that the web app deployment is Execute as Me, Who has access Anyone.');
      }, function () {
        throw new Error('The browser cannot reach the sheet script at all (' + hookShort + '). Open that address in a private window: a Google sign in page means the deployment must be Execute as Me, Who has access Anyone (Deploy, Manage deployments, pencil). If it shows ok:true there, an ad blocker or network filter is stopping script.google.com here.');
      });
    }).then(function (data) {
      if (data && data.error === 'bad passcode') {
        sessionStorage.removeItem(PASS_KEY);
        showGate('Wrong passcode. Check the PASSCODE row of the Config tab in the sheet.');
        throw new Error('bad passcode');
      }
      if (data && data.ok === false && data.error && /unknown action/i.test(data.error)) {
        throw new Error('The sheet script is older than this theme. Paste the new Code.gs into the Apps Script editor and deploy a New version.');
      }
      return data;
    });
  }
  window.__wmgPostJson = postJson;
  window.__wmgApi = api;

  /* ---------- gate ---------- */
  function showGate(msg) {
    show($('pgx-gate'), true);
    show($('pgx-app'), false);
    status($('pgx-gate-st'), msg || '', msg ? 'err' : '');
  }
  function showApp() {
    show($('pgx-gate'), false);
    show($('pgx-app'), true);
    paintHealth();
    setPane('import');
  }
  function loadHealth() {
    return api('health', {}).then(function (res) {
      state.health = (res && res.config) || res || {};
      if (res && res.version) $('pgx-ver').textContent = 'engine v' + res.version;
      window.__wmgHealth = state.health;
      paintHealth();
    }).catch(function () {});
  }
  var unlocking = false;
  function tryUnlock() {
    var v = $('pgx-pass').value.trim();
    if (!v || unlocking) return;
    unlocking = true;
    $('pgx-enter').disabled = true;
    sessionStorage.setItem(PASS_KEY, v);
    status($('pgx-gate-st'), 'Checking...');
    api('verify', {}).then(function (res) {
      if (res && res.ok) { showApp(); return loadHealth(); }
      sessionStorage.removeItem(PASS_KEY);
      showGate((res && res.error) || 'Wrong passcode.');
    }).catch(function (err) {
      if (err.message !== 'bad passcode') showGate(err.message);
    }).then(function () { unlocking = false; $('pgx-enter').disabled = false; });
  }
  $('pgx-enter').addEventListener('click', function (e) { e.preventDefault(); tryUnlock(); });
  $('pgx-pass').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); tryUnlock(); } });

  /* ---------- health banner ---------- */
  function paintHealth() {
    var h = state.health || {};
    var dry = h.dryRun !== false;
    var box = $('pgx-mode');
    box.className = 'pgx-banner ' + (dry ? 'test' : 'live');
    $('pgx-mode-text').innerHTML = dry
      ? '<b>Test mode is on.</b> Imports show you exactly what would be created, and create nothing. When a preview looks right, open the Google Sheet, Config tab, set <b>DRY_RUN</b> to 0, and send it again.'
      : '<b>Live mode.</b> Sending a listing creates a real product on the store immediately.';
    var chips = $('pgx-chips');
    chips.innerHTML = '';
    function chip(label, on) {
      var s = document.createElement('span');
      s.className = 'pgx-chip ' + (on ? 'on' : 'off');
      s.textContent = label + (on ? ' ok' : ' missing');
      chips.appendChild(s);
    }
    if (!state.health) { chips.innerHTML = ''; var w = document.createElement('span'); w.className = 'pgx-chip'; w.textContent = 'reading the sheet config...'; chips.appendChild(w); $('pgx-mode-text').innerHTML = '<b>Connected.</b> Checking the sheet config...'; paintSendCopy(); return; }
    chip('Shopify connection', !!h.shopify);
    chip('Passcode', h.passcodeSet !== false);
    var m = document.createElement('span');
    m.className = 'pgx-chip';
    m.textContent = 'pricing \u00d7' + (h.priceMultiplier || 1.35) + ' \u2192 ' + (h.storeCurrency || 'USD');
    chips.appendChild(m);
    paintSendCopy();
  }

  /* ---------- store setup ---------- */
  $('pgx-setup-btn').addEventListener('click', function () {
    var btn = $('pgx-setup-btn');
    btn.disabled = true;
    status($('pgx-setup-st'), 'Building...');
    $('pgx-setup-out').innerHTML = '';
    api('setup_store', {
      pages: $('pgx-s-pages').checked,
      collections: $('pgx-s-cols').checked,
      menu: $('pgx-s-menu').checked
    }).then(function (res) {
      btn.disabled = false;
      var list = (res && res.results) || [];
      var fails = 0;
      list.forEach(function (r) {
        var li = document.createElement('li');
        li.className = r.ok ? 'ok' : 'fail';
        li.textContent = r.step + (r.note ? ' \u2014 ' + r.note : '');
        if (!r.ok) fails++;
        $('pgx-setup-out').appendChild(li);
      });
      status($('pgx-setup-st'), fails ? fails + ' step(s) failed' : 'All green. You are done with setup.', fails ? 'err' : 'ok');
    }).catch(function (err) {
      btn.disabled = false;
      if (err.message !== 'bad passcode') status($('pgx-setup-st'), err.message, 'err');
    });
  });

  /* ---------- fetch listing ---------- */
  $('pgx-fetch').addEventListener('click', function () {
    var url = $('pgx-url').value.trim();
    if (!url) { status($('pgx-fetch-st'), 'Paste a link first', 'err'); return; }
    var btn = $('pgx-fetch');
    btn.disabled = true;
    status($('pgx-fetch-st'), 'Reading the page...');
    api('import', { url: url }).then(function (res) {
      btn.disabled = false;
      if (!res || !res.success) throw new Error((res && res.error) || 'Could not read that page.');
      state.product = res.product || {};
      state.suggested = res.suggested || null;
      state.images = (state.product.images || []).filter(function (src) { return /^https:\/\//i.test(String(src || '').trim()); }).map(function (src) { return { src: src.trim(), keep: true }; });
      fillEditor(res);
      if (!state.specEd) {
        state.specEd = window.__wmgSpecs($('pgx-specs'), {});
        state.specEd.onChange = function () { paintPreview(); };
        state.sight = window.__wmgSightBox($('pgx-sight'));
        state.sight.input.addEventListener('change', function () { paintPreview(); });
      }
      state.specEd.set(state.product.specifications || {});
      state.sight.set(false);
      if (!state.pagePick) state.pagePick = window.__wmgPages($('pgx-pages'), state.mode === 'backshelf' ? 'backshelf' : 'importing');
      else state.pagePick.set([]);
      window.__wmgAuction($('pgx-auction'), res.auction);
      renderPhotos();
      if (!state._finishCfg) {
        state._finishCfg = { addBtn: 'pgx-finishadd', nameInput: 'pgx-finishname', list: 'pgx-finishlist', photos: 'pgx-photos', getImages: function () { return state.images; }, state: state, exportName: '_wmgFinImport', onChange: function () { paintPreview(); } };
        if (window.__wmgFinishBuild) window.__wmgFinishBuild(state._finishCfg);
      } else if (state._finishCfg.repaint) { state.finishes = []; state._finishCfg.repaint(); }
      paintPreview();
      status($('pgx-fetch-st'), res.status === 'complete' ? '' : 'Some fields need a look', res.status === 'complete' ? 'ok' : '');
      show($('pgx-editor'), true);
      show($('pgx-previewcard'), true);
      show($('pgx-sender'), true);
      paintSendCopy();
    }).catch(function (err) {
      btn.disabled = false;
      if (err.message !== 'bad passcode') status($('pgx-fetch-st'), err.message, 'err');
    });
  });

  function fillEditor(res) {
    var p = state.product;
    $('pgx-title').value = p.title || '';
    $('pgx-brand').value = p.manufacturer || '';
    $('pgx-type').value = p.category || guessType(p);
    $('pgx-desc').value = p.description || '';
    $('pgx-srcprice').value = p.price != null ? (p.currency || '') + ' ' + p.price : 'not found';
    if ($('pgx-srccur')) $('pgx-srccur').value = 'auto';
    $('pgx-veh').value = (p.fitment || []).map(function (f) {
      return [f.make, f.model, f.chassis].filter(Boolean).join(' ');
    }).join('\n');
    var s = state.suggested;
    if (s) {
      $('pgx-price').value = s.price;
      $('pgx-cur').textContent = s.currency;
      $('pgx-math').innerHTML = 'Suggested price: <b>' + s.currency + ' ' + s.price + '</b> &mdash; ' + esc(s.math) + '. Edit it freely before sending.';
    } else {
      $('pgx-price').value = '';
      $('pgx-math').textContent = 'No price found on the source page, so type the listing price yourself.';
    }
    var warn = (res.warnings || []).concat((res.missingFields || []).length ? ['Missing from the page: ' + res.missingFields.join(', ')] : []);
    if (warn.length) $('pgx-math').innerHTML += '<br>' + warn.map(function (w) { return '\u26a0 ' + esc(w); }).join('<br>');
  }

  /* ---------- photos ---------- */
  function renderPhotos() {
    var box = $('pgx-photos');
    box.innerHTML = '';
    $('pgx-imgcount').textContent = state.images.length ? '(' + state.images.length + ' found)' : '(none found)';
    if (!state.images.length) {
      box.innerHTML = '<div class="pgx-empty">The source page did not expose any photos to the reader.</div>';
      return;
    }
    state.images.forEach(function (im, i) {
      var d = document.createElement('div');
      d.className = 'pgx-ph' + (im.keep ? '' : ' drop');
      d.setAttribute('data-src', im.src);
      var img = document.createElement('img');
      img.src = im.src;
      img.loading = 'lazy';
      img.referrerPolicy = 'no-referrer';
      img.onerror = function () { d.classList.add('blocked'); img.style.display = 'none'; };
      var k = document.createElement('div');
      k.className = 'k';
      k.textContent = im.keep ? 'keep' : 'dropped';
      d.appendChild(img);
      d.appendChild(k);
      d.addEventListener('click', function () {
        im.keep = !im.keep;
        d.classList.toggle('drop', !im.keep);
        k.textContent = im.keep ? 'keep' : 'dropped';
        if (state._finishCfg && state._finishCfg.dropped) state._finishCfg.dropped(im.src, !im.keep);
        paintPreview();
      });
      box.appendChild(d);
    });
  }
  function keptImages() {
    return state.images.filter(function (i) { return i.keep; }).map(function (i) { return i.src; });
  }

  if ($('pgx-srccur')) $('pgx-srccur').addEventListener('change', function () {
    var p = state.product;
    if (!p || p.price == null) return;
    var cur = $('pgx-srccur').value;
    var useCur = cur === 'auto' ? (p.currency || 'JPY') : cur;
    $('pgx-srcprice').value = useCur + ' ' + p.price;
    api('suggest', { price: p.price, currency: useCur }).then(function (res) {
      if (res && res.ok && res.suggested) {
        state.suggested = res.suggested;
        $('pgx-price').value = res.suggested.price;
        $('pgx-cur').textContent = res.suggested.currency;
        $('pgx-math').innerHTML = 'Suggested price: <b>' + res.suggested.currency + ' ' + res.suggested.price + '</b> &mdash; ' + esc(res.suggested.math) + '. Edit it freely before sending.';
        paintPreview();
      }
    }).catch(function () {});
  });

  /* ---------- mode toggle ---------- */
  function setMode(m) {
    state.mode = m;
    if (state.pagePick) state.pagePick.home(m === 'backshelf' ? 'backshelf' : 'importing');
    var labels = $('pgx-modes').querySelectorAll('label');
    Array.prototype.forEach.call(labels, function (l) {
      l.classList[l.getAttribute('data-mode') === m ? 'add' : 'remove']('sel');
    });
    show($('pgx-back-opts'), m === 'backshelf');
    show($('pgx-imp-opts'), m === 'import');
    paintSendCopy();
    paintPreview();
  }
  Array.prototype.forEach.call(document.getElementsByName('pgx-mode'), function (r) {
    r.addEventListener('change', function () { setMode(r.value); });
  });
  setMode('import');

  /* ---------- live preview ---------- */
  function condLabel(v) { return String(v || '').replace(/-/g, ' ').replace(/^\w/, function (c) { return c.toUpperCase(); }); }
  function paintPreview() {
    var pv = $('pgx-pv');
    if (!state.product) { pv.innerHTML = ''; return; }
    var imgs = keptImages();
    var title = $('pgx-title').value.trim() || 'Untitled part';
    var brand = $('pgx-brand').value.trim();
    var priceVal = $('pgx-price').value;
    var cur = (state.suggested && state.suggested.currency) || (state.health && state.health.storeCurrency) || 'USD';
    var isBuy = state.mode === 'backshelf';
    var eyebrow = (isBuy ? 'On the shelf' : 'Request item') + ' / ' + (isBuy ? condLabel($('pgx-cond').value) : 'Inspected');
    var specs = [];
    if (brand) specs.push(['Brand', brand]);
    if ($('pgx-type').value.trim()) specs.push(['Type', $('pgx-type').value.trim()]);
    if (isBuy) specs.push(['Condition', condLabel($('pgx-cond').value)]);
    else if ($('pgx-lead').value.trim()) specs.push(['Lead time', $('pgx-lead').value.trim()]);
    var sp = state.specEd ? state.specEd.get() : (state.product.specifications || {});
    Object.keys(sp).slice(0, 8).forEach(function (k) { specs.push([k, sp[k]]); });
    var fins = (state._finishCfg && state._finishCfg.collect) ? state._finishCfg.collect() : [];
    if (state._pvFinish && !fins.some(function (f) { return f.name === state._pvFinish; })) state._pvFinish = '';
    if (state._pvFinish) imgs = fins.filter(function (f) { return f.name === state._pvFinish; })[0].images;
    var fits = $('pgx-veh').value.split('\n').map(function (x) { return x.trim(); }).filter(Boolean);
    var desc = $('pgx-desc').value.trim();

    var hero = imgs.length
      ? '<img src="' + esc(imgs[0]) + '" referrerpolicy="no-referrer" onerror="this.style.display=\'none\';this.parentElement.innerHTML=\'<div class=ph>Photo uploads with the product</div>\'">'
      : '<div class="ph">' + (state.images.length ? 'All photos dropped' : 'No photo on the source page') + '</div>';
    var thumbs = imgs.slice(1, 5).map(function (u) {
      return '<div><img src="' + esc(u) + '" referrerpolicy="no-referrer" onerror="this.style.display=\'none\'"></div>';
    }).join('');

    pv.innerHTML =
      '<div class="pgx-pv-grid">' +
        '<div><div class="pgx-pv-hero">' + hero + '</div>' +
          (thumbs ? '<div class="pgx-pv-thumbs">' + thumbs + '</div>' : '') + '</div>' +
        '<div>' +
          '<div class="pgx-pv-eyebrow">' + esc(eyebrow) + '</div>' +
          '<h4 class="pgx-pv-title">' + esc(title) + '</h4>' +
          '<div class="pgx-pv-sub">' + esc(brand || 'Wont Miss Garage') + '</div>' +
          '<div class="pgx-pv-price"><b>' + (priceVal ? esc(cur + ' ' + priceVal) : 'Quote') + '</b></div>' +
          '<span class="pgx-pv-btn">' + (isBuy ? 'Add to cart' : 'Request this item') + '</span>' +
          (specs.length ? '<table>' + specs.map(function (r) { return '<tr><th>' + esc(r[0]) + '</th><td>' + esc(r[1]) + '</td></tr>'; }).join('') + '</table>' : '') +
          (fins.length ? '<div class="pgx-pv-fins">' + fins.map(function (f) { return '<span data-fin="' + esc(f.name) + '" class="' + (f.name === state._pvFinish ? 'on' : '') + '">' + esc(f.name) + ' \u00b7 ' + f.images.length + '</span>'; }).join('') + '</div>' : '') +
          (state.sight && state.sight.get() ? '<div class="pgx-pv-note warn">Sight unseen disclaimer shown on the item page</div>' : '') +
          (fits.length ? '<div class="pgx-pv-fits">' + fits.map(function (f) { return '<span>' + esc(f) + '</span>'; }).join('') + '</div>' : '') +
          (desc ? '<div class="pgx-pv-desc">' + esc(desc) + '</div>' : '') +
        '</div>' +
      '</div>';
    // clicking a finish chip previews exactly what a buyer sees after choosing that finish
    pv.querySelectorAll('[data-fin]').forEach(function (sp2) { sp2.addEventListener('click', function () { var n = sp2.getAttribute('data-fin'); state._pvFinish = state._pvFinish === n ? '' : n; paintPreview(); }); });
  }
  ['pgx-title', 'pgx-brand', 'pgx-type', 'pgx-price', 'pgx-cond', 'pgx-lead', 'pgx-veh', 'pgx-desc', 'pgx-shelf'].forEach(function (id) {
    var el = $(id);
    if (el) { el.addEventListener('input', paintPreview); el.addEventListener('change', paintPreview); }
  });

  /* ---------- send ---------- */
  function paintSendCopy() {
    var h = state.health || {};
    var dry = h.dryRun !== false;
    $('pgx-send').textContent = dry ? 'Run test send (creates nothing)' : 'Create product on store';
    show($('pgx-test-row'), !dry);
    $('pgx-send-copy').textContent = dry
      ? 'Test mode: this checks the whole pipeline and shows what would be created, without creating it. The preview above is how it will look.'
      : (state.mode === 'backshelf'
        ? 'This creates a live, buyable product and files it into the Backshelf shelf.'
        : 'This creates a live request listing and files it into its shelf.');
  }

  function collectProduct() {
    var p = Object.assign({}, state.product || {});
    p.title = $('pgx-title').value.trim();
    p.manufacturer = $('pgx-brand').value.trim();
    p.description = $('pgx-desc').value;
    p.images = keptImages();
    if (state.specEd) p.specifications = state.specEd.get();
    return p;
  }
  function collectOptions() {
    var m = state.mode;
    return {
      mode: m,
      price: $('pgx-price').value ? Number($('pgx-price').value) : null,
      productType: $('pgx-type').value.trim() || null,
      quantity: m === 'backshelf' ? Number($('pgx-qty').value || 0) : 0,
      condition: m === 'backshelf' ? $('pgx-cond').value : null,
      shelf: m === 'import' ? 'source-import' : null,
      leadTime: m === 'import' ? ($('pgx-lead').value.trim() || null) : null,
      testProduct: !!($('pgx-test') && $('pgx-test').checked),
      sourceCurrency: ($('pgx-srccur') && $('pgx-srccur').value !== 'auto') ? $('pgx-srccur').value : null,
      vehicles: $('pgx-veh').value.split('\n').map(function (s) { return s.trim(); }).filter(Boolean),
      extraTags: $('pgx-tags').value.split(',').map(function (s) { return s.trim(); }).filter(Boolean),
      finishes: (state._finishCfg && state._finishCfg.collect) ? state._finishCfg.collect() : [],
      sightUnseen: !!(state.sight && state.sight.get()),
      pages: state.pagePick ? state.pagePick.get() : []
    };
  }

  $('pgx-send').addEventListener('click', function () {
    var btn = $('pgx-send');
    btn.disabled = true;
    status($('pgx-send-st'), 'Sending...');
    $('pgx-out').innerHTML = '';
    api('publish', { product: collectProduct(), options: collectOptions() }).then(function (res) {
      btn.disabled = false;
      status($('pgx-send-st'), '');
      var box = document.createElement('div');
      if (res && res.ok && res.dryRun) {
        box.className = 'pgx-result dry';
        box.innerHTML = '<h3>Test passed, nothing was created</h3>' +
          '<div>The listing above is what buyers would see. To put it on the store for real: open the Google Sheet, Config tab, set <b>DRY_RUN</b> to <b>0</b>, come back and press the button again.</div>' +
          (res.warnings && res.warnings.length ? '<div style="margin-top:8px">' + res.warnings.map(esc).join('<br>') + '</div>' : '') +
          '<details style="margin-top:10px"><summary class="pgx-mono" style="cursor:pointer">Technical payload</summary><pre>' + esc(JSON.stringify(res.payload, null, 2)) + '</pre></details>';
      } else if (res && res.ok) {
        box.className = 'pgx-result good';
        var wasTest = $('pgx-test') && $('pgx-test').checked;
        box.innerHTML = '<h3>Live on the store' + (wasTest ? ' as a $0 test product' : '') + '</h3>' +
          '<div>' + (wasTest
            ? 'Buy it through checkout now to try the whole pipeline for free, watch the Orders tab in the sheet, then remove it from Live listings.'
            : 'It files itself into its shelf from its tags. The line below watches that happen.') + '</div>' +
          '<div style="margin-top:10px"><a href="' + esc((res.storefrontUrl || '#') + (res.storefrontUrl ? '?wmg_preview=1' : '')) + '" target="_blank" rel="noopener">Open the product page</a>' +
          ' &nbsp;&middot;&nbsp; <a href="' + esc(res.adminUrl || '#') + '" target="_blank" rel="noopener">Open in Shopify admin</a></div>' +
          (res.warnings && res.warnings.length ? '<div style="margin-top:10px">' + res.warnings.map(esc).join('<br>') + '</div>' : '');
        if (window.__wmgWatchPublish) window.__wmgWatchPublish(box, res, api);
      } else {
        box.className = 'pgx-result bad';
        box.innerHTML = '<h3>That did not go through</h3><div>' + esc((res && (res.error || (res.errors || []).join('; '))) || 'Unknown error') + '</div>';
      }
      $('pgx-out').appendChild(box);
    }).catch(function (err) {
      btn.disabled = false;
      if (err.message !== 'bad passcode') status($('pgx-send-st'), err.message, 'err');
    });
  });

  /* ---------- manage listings ---------- */
  function loadListings() {
    var box = $('pgx-list');
    box.innerHTML = '<div class="pgx-empty">Loading...</div>';
    api('listings', {}).then(function (res) {
      if (!res || !res.ok) throw new Error((res && res.error) || 'Could not load listings.');
      var items = res.items || [];
      box.innerHTML = '';
      if (!items.length) {
        box.innerHTML = '<div class="pgx-empty">Nothing on the shelf yet. Live sends will appear here.</div>';
        return;
      }
      items.forEach(function (it) {
        var row = document.createElement('div');
        row.className = 'pgx-row';
        row.innerHTML =
          '<div class="im">' + (it.image ? '<img src="' + esc(it.image) + '">' : '') + '</div>' +
          '<div class="tt"><b>' + esc(it.title) + '</b><span>' + esc(it.shelf) + ' &middot; ' + esc(it.price || '') + (it.status !== 'ACTIVE' ? ' \u00b7 ' + esc(it.status) : '') + '</span>' +
          '<span class="pgx-stock" data-stock="' + (it.sold ? 'sold' : 'ok') + '">' + esc(it.stockLabel || '') + '</span></div>' +
          '<a href="' + esc(it.url) + '" target="_blank" rel="noopener">View</a>' +
          '<a href="' + esc(it.adminUrl) + '" target="_blank" rel="noopener">Admin</a>';
        var isActive = it.status === 'ACTIVE';
        // stock: available / sold / exact count, written to Shopify and mirrored on the site
        var st = document.createElement('div');
        st.className = 'pgx-stockctl';
        var stockLabel = row.querySelector('.pgx-stock');
        function setStock(mode, quantity, btn) {
          var all = st.querySelectorAll('button, input');
          all.forEach(function (x) { x.disabled = true; });
          if (btn) btn.textContent = 'Saving\u2026';
          api('stock', { id: it.id, mode: mode, quantity: quantity }).then(function (r2) {
            if (!r2 || !r2.ok) throw new Error((r2 && r2.error) || 'Could not update stock.');
            it.sold = r2.sold; it.quantity = r2.quantity; it.stockLabel = r2.stockLabel;
            stockLabel.textContent = r2.stockLabel;
            stockLabel.setAttribute('data-stock', r2.sold ? 'sold' : 'ok');
            paint();
          }).catch(function (err) { paint(); if (err.message !== 'bad passcode') alert(err.message); });
        }
        function paint() {
          st.innerHTML = '';
          var av = document.createElement('button'); av.type = 'button'; av.className = 'pgx-st' + (it.sold ? '' : ' on'); av.textContent = it.sold ? 'Mark available' : '\u2713 Available';
          av.title = 'Back on the shelf with one in stock';
          av.addEventListener('click', function () { if (it.sold) setStock('available', 1, av); });
          var so = document.createElement('button'); so.type = 'button'; so.className = 'pgx-st' + (it.sold ? ' on' : ''); so.textContent = it.sold ? '\u2713 Sold' : 'Mark sold';
          so.title = 'Stock to zero, shown as Sold on the site';
          so.addEventListener('click', function () { if (!it.sold) setStock('sold', 0, so); });
          var q = document.createElement('input'); q.type = 'number'; q.min = '0'; q.step = '1'; q.className = 'pgx-qty'; q.placeholder = 'qty';
          q.value = (it.quantity == null ? '' : it.quantity);
          var set = document.createElement('button'); set.type = 'button'; set.className = 'pgx-st'; set.textContent = 'Set';
          set.title = 'Exact quantity in stock. Under 20 shows "Only N left" on the site.';
          set.addEventListener('click', function () { var n = parseInt(q.value, 10); if (isNaN(n) || n < 0) { q.focus(); return; } setStock('quantity', n, set); });
          q.addEventListener('keydown', function (e) { if (e.key === 'Enter') set.click(); });
          st.appendChild(av); st.appendChild(so); st.appendChild(q); st.appendChild(set);
        }
        paint();
        row.appendChild(st);
        // pages: its own page stays, the rest can be ticked on or off and saved
        var pg = document.createElement('div');
        pg.className = 'pgx-pagectl';
        var pick = window.__wmgPages(pg, it.homePage || '', true);
        pick.set(it.pages || []);
        var save = document.createElement('button'); save.type = 'button'; save.className = 'pgx-st'; save.textContent = 'Save pages';
        var note = document.createElement('span'); note.className = 'pgx-pagenote';
        save.addEventListener('click', function () {
          save.disabled = true; save.textContent = 'Saving\u2026'; note.textContent = '';
          api('pages', { id: it.id, pages: pick.get() }).then(function (r3) {
            if (!r3 || !r3.ok) throw new Error((r3 && r3.error) || 'Could not update pages.');
            it.pages = r3.pages; pick.set(r3.pages);
            note.textContent = r3.pages.length ? 'Also on: ' + r3.pages.join(', ') : 'Only on its own page';
          }).catch(function (err) { if (err.message !== 'bad passcode') note.textContent = err.message; })
            .then(function () { save.disabled = false; save.textContent = 'Save pages'; });
        });
        pg.appendChild(save); pg.appendChild(note);
        row.appendChild(pg);
        var hd = document.createElement('button');
        hd.className = 'pgx-hd';
        hd.textContent = isActive ? 'Hide' : 'Publish';
        hd.title = isActive ? 'Take it off the website, keep it in Shopify admin' : 'Put it back on the website';
        hd.addEventListener('click', function () {
          if (isActive && !confirm('Hide "' + it.title + '" from the website?\n\nIt stays in Shopify admin as a draft, and you can publish it again from here.')) return;
          hd.disabled = true;
          api('remove', { id: it.id, mode: isActive ? 'hide' : 'restore' }).then(function (r2) {
            if (!r2 || !r2.ok) throw new Error((r2 && r2.error) || 'Failed.');
            loadListings();
          }).catch(function (err) { hd.disabled = false; if (err.message !== 'bad passcode') alert(err.message); });
        });
        var rm = document.createElement('button');
        rm.className = 'pgx-rm';
        rm.textContent = 'Delete';
        rm.addEventListener('click', function () {
          if (!confirm('Delete "' + it.title + '" everywhere?\n\nThis removes it from the website AND from Shopify admin. It cannot be undone.')) return;
          rm.disabled = true;
          rm.textContent = 'Deleting...';
          api('remove', { id: it.id, mode: 'delete' }).then(function (r2) {
            if (!r2 || !r2.ok) throw new Error((r2 && r2.error) || 'Delete failed.');
            row.remove();
            if (!box.querySelector('.pgx-row')) box.innerHTML = '<div class="pgx-empty">Nothing on the shelf yet. Live sends will appear here.</div>';
          }).catch(function (err) {
            rm.disabled = false;
            rm.textContent = 'Delete';
            if (err.message !== 'bad passcode') alert(err.message);
          });
        });
        row.appendChild(hd);
        row.appendChild(rm);
        box.appendChild(row);
      });
    }).catch(function (err) {
      if (err.message !== 'bad passcode') box.innerHTML = '<div class="pgx-empty">' + esc(err.message) + '</div>';
    });
  }
  $('pgx-list-refresh').addEventListener('click', function (e) { e.preventDefault(); loadListings(); });

  /* ---------- boot ---------- */
  if (sessionStorage.getItem(PASS_KEY)) {
    api('verify', {}).then(function (res) {
      if (res && res.ok) { showApp(); return loadHealth(); }
      showGate();
    }).catch(function () { showGate(); });
  } else {
    showGate();
  }
})();

/* ---------- wheels lane: photos and name off the link, sizes by hand ---------- */
(function () {
  var root = document.getElementById('pgx');
  if (!root || !document.getElementById('pgw-fetch')) return;
  var HOOK = (root.getAttribute('data-webhook') || '').trim();
  var W = { product: null, suggested: null, images: [] };
  function $(id) { return document.getElementById(id); }
  function st(el, m, c) { el.textContent = m || ''; el.className = 'pgx-status' + (c ? ' ' + c : ''); }
  function esc2(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function wapi(action, body) {
    var payload = Object.assign({ action: action, passcode: sessionStorage.getItem('wmg_prop_pass') || '' }, body || {});
    if (window.__wmgPostJson) return window.__wmgPostJson(payload);
    return fetch(HOOK, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload), redirect: 'follow' }).then(function (r) { return r.json(); });
  }
  function paintPhotos() {
    var box = $('pgw-photos');
    box.innerHTML = '';
    $('pgw-imgcount').textContent = W.images.length ? '(' + W.images.length + ' found)' : '(none found)';
    if (!W.images.length) { box.innerHTML = '<div class="pgx-empty">No photos exposed on that page.</div>'; return; }
    W.images.forEach(function (im) {
      var d = document.createElement('div');
      d.className = 'pgx-ph' + (im.keep ? '' : ' drop');
      d.setAttribute('data-src', im.src);
      var img = document.createElement('img');
      img.src = im.src; img.loading = 'lazy'; img.referrerPolicy = 'no-referrer';
      img.onerror = function () { d.classList.add('blocked'); img.style.display = 'none'; };
      var k = document.createElement('div'); k.className = 'k'; k.textContent = im.keep ? 'keep' : 'dropped';
      d.appendChild(img); d.appendChild(k);
      d.addEventListener('click', function () { im.keep = !im.keep; d.classList.toggle('drop', !im.keep); k.textContent = im.keep ? 'keep' : 'dropped'; if (W._finishCfg && W._finishCfg.dropped) W._finishCfg.dropped(im.src, !im.keep); });
      box.appendChild(d);
    });
  }
  $('pgw-fetch').addEventListener('click', function () {
    var url = $('pgw-url').value.trim();
    if (!url) { st($('pgw-fetch-st'), 'Paste a link first', 'err'); return; }
    var btn = $('pgw-fetch'); btn.disabled = true;
    st($('pgw-fetch-st'), 'Reading the page...');
    wapi('import', { url: url }).then(function (res) {
      btn.disabled = false;
      if (!res || !res.success) throw new Error((res && res.error) || 'Could not read that page.');
      W.product = res.product || {};
      W.suggested = res.suggested || null;
      W.images = (W.product.images || []).filter(function (u) { return /^https:\/\//i.test(String(u || '').trim()); }).map(function (u) { return { src: u.trim(), keep: true }; });
      $('pgw-name').value = W.product.title || '';
      $('pgw-brand').value = W.product.manufacturer || '';
      if (W.suggested) {
        $('pgw-price').value = W.suggested.price;
        $('pgw-cur').textContent = W.suggested.currency;
        $('pgw-math').innerHTML = 'Suggested price: <b>' + W.suggested.currency + ' ' + W.suggested.price + '</b> &mdash; ' + esc2(W.suggested.math);
        $('pgw-math').classList.remove('pgx-hide');
      } else {
        $('pgw-price').value = '';
        $('pgw-math').classList.add('pgx-hide');
      }
      $('pgw-desc').value = W.product.description || '';
      if (!W.specEd) { W.specEd = window.__wmgSpecs($('pgw-specs'), {}); W.sight = window.__wmgSightBox($('pgw-sight')); }
      W.specEd.set(W.product.specifications || {});
      W.sight.set(false);
      if (!W.pagePick) W.pagePick = window.__wmgPages($('pgw-pages'), 'wheels'); else W.pagePick.set([]);
      window.__wmgAuction($('pgw-auction'), res.auction);
      paintPhotos();
      if (!W._finishCfg) { W._finishCfg = { addBtn: 'pgw-finishadd', nameInput: 'pgw-finishname', list: 'pgw-finishlist', photos: 'pgw-photos', getImages: function () { return W.images; }, state: W, exportName: '_wmgFinWheel' }; if (window.__wmgFinishBuild) window.__wmgFinishBuild(W._finishCfg); }
      else if (W._finishCfg.repaint) { W.finishes = []; W._finishCfg.repaint(); }
      $('pgw-editor').classList.remove('pgx-hide');
      $('pgw-send-copy').textContent = 'Sizes become the shop filters, so double check diameter and bolt pattern. Test and live mode behave the same as the main import lane.';
      st($('pgw-fetch-st'), '', 'ok');
    }).catch(function (err) { btn.disabled = false; st($('pgw-fetch-st'), err.message, 'err'); });
  });
  $('pgw-send').addEventListener('click', function () {
    var list = function (id, fix) {
      return $(id).value.split(',').map(function (v) { v = v.trim(); return fix ? fix(v) : v; }).filter(Boolean);
    };
    var dia = list('pgw-dia');
    var pcd = list('pgw-pcd', function (v) { return v.replace(/x/gi, '\u00d7'); });
    if (!dia.length || !pcd.length) { st($('pgw-send-st'), 'Diameter and bolt pattern are required', 'err'); return; }
    var btn = $('pgw-send'); btn.disabled = true;
    st($('pgw-send-st'), 'Sending...');
    $('pgw-out').innerHTML = '';
    var kept = W.images.filter(function (i) { return i.keep; }).map(function (i) { return i.src; });
    var product = Object.assign({}, W.product || {}, {
      title: $('pgw-name').value.trim() || 'Wheel set',
      manufacturer: $('pgw-brand').value.trim(),
      images: kept,
      description: $('pgw-desc').value,
      specifications: W.specEd ? W.specEd.get() : {},
      fitment: []
    });
    var options = {
      mode: 'backshelf', wheel: true, productType: 'Wheels',
      price: $('pgw-price').value ? Number($('pgw-price').value) : null,
      leadTime: $('pgw-lead').value.trim() || null,
      condition: $('pgw-cond').value,
      dia: dia, width: list('pgw-width'), et: list('pgw-et'),
      pcd: pcd, bore: list('pgw-bore'),
      vehicles: [], extraTags: [],
      finishes: (W._finishCfg && W._finishCfg.collect) ? W._finishCfg.collect() : [],
      sightUnseen: !!(W.sight && W.sight.get()),
      pages: W.pagePick ? W.pagePick.get() : []
    };
    wapi('publish', { product: product, options: options }).then(function (res) {
      btn.disabled = false; st($('pgw-send-st'), '');
      var box = document.createElement('div');
      if (res && res.ok && res.dryRun) {
        box.className = 'pgx-result dry';
        box.innerHTML = '<h3>Test passed, nothing was created</h3><div>Flip DRY_RUN to 0 in the sheet and send again to put it on the store.</div><details style="margin-top:10px"><summary class="pgx-mono" style="cursor:pointer">Technical payload</summary><pre>' + esc2(JSON.stringify(res.payload, null, 2)) + '</pre></details>';
      } else if (res && res.ok) {
        box.className = 'pgx-result good';
        box.innerHTML = '<h3>Live on the store</h3><div>Any size given as a range is a dropdown on its listing, and the chosen sizes, finish and the ship-to address ride through checkout into the Wheel Orders tab.</div><div style="margin-top:10px"><a href="' + esc2((res.storefrontUrl || '#') + (res.storefrontUrl ? '?wmg_preview=1' : '')) + '" target="_blank" rel="noopener">Open the product page</a> &nbsp;&middot;&nbsp; <a href="' + esc2(res.adminUrl || '#') + '" target="_blank" rel="noopener">Open in Shopify admin</a></div>' +
          (res.warnings && res.warnings.length ? '<div style="margin-top:10px">' + res.warnings.map(esc2).join('<br>') + '</div>' : '');
        if (window.__wmgWatchPublish) window.__wmgWatchPublish(box, res, wapi);
      } else {
        box.className = 'pgx-result bad';
        box.innerHTML = '<h3>That did not go through</h3><div>' + esc2((res && (res.error || (res.errors || []).join('; '))) || 'Unknown error') + '</div>';
      }
      $('pgw-out').appendChild(box);
    }).catch(function (err) { btn.disabled = false; st($('pgw-send-st'), err.message, 'err'); });
  });
})();

/* ---------- visual finish builder: shared across both propagator lanes ---------- */
(function () {
  function esc4(s){return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];});}
  function build(cfg) {
    var addBtn = document.getElementById(cfg.addBtn);
    if (!addBtn) return;
    var nameInput = document.getElementById(cfg.nameInput);
    var listEl = document.getElementById(cfg.list);
    cfg.state.finishes = cfg.state.finishes || []; // [{name, picks:Set}]
    var active = -1;

    function keptImages() { return cfg.getImages().filter(function (i) { return i.keep; }); }
    function tileSrc(box) { return box.getAttribute('data-src') || ''; }

    function render() {
      if (cfg.onChange) { try { cfg.onChange(); } catch (e) {} }
      listEl.innerHTML = '';
      cfg.state.finishes.forEach(function (f, fi) {
        var row = document.createElement('div');
        row.style.cssText = 'display:flex;align-items:center;gap:10px;padding:8px 10px;border:1px solid ' + (fi === active ? '#111110' : '#d9d7cf') + ';margin-bottom:6px;cursor:pointer';
        row.innerHTML = '<b style="font-size:13px;flex:1">' + esc4(f.name) + '</b>' +
          '<span style="font-family:\'JetBrains Mono\',monospace;font-size:9px;color:#6f6c64">' + f.picks.size + ' photo' + (f.picks.size === 1 ? '' : 's') + '</span>';
        var del = document.createElement('button');
        del.type = 'button'; del.textContent = '×';
        del.style.cssText = 'border:0;background:transparent;color:#a8221c;font-size:18px;cursor:pointer;line-height:1';
        del.addEventListener('click', function (e) { e.stopPropagation(); cfg.state.finishes.splice(fi, 1); if (active >= cfg.state.finishes.length) active = -1; render(); paintPhotos(); });
        row.appendChild(del);
        row.addEventListener('click', function () { active = (active === fi ? -1 : fi); render(); paintPhotos(); });
        listEl.appendChild(row);
      });
      var hint = document.createElement('div');
      hint.style.cssText = 'display:flex;align-items:center;gap:12px;font-family:\'JetBrains Mono\',monospace;font-size:9px;letter-spacing:0.06em;color:#6f6c64;padding-top:6px';
      if (active >= 0) {
        var span = document.createElement('span');
        span.textContent = 'Selecting photos for "' + cfg.state.finishes[active].name + '": click the photos above to add or remove them';
        var done = document.createElement('button');
        done.type = 'button';
        done.textContent = '\u2713 Done';
        done.style.cssText = 'border:1px solid #1d7a3a;background:#1d7a3a;color:#fff;font-family:\'JetBrains Mono\',monospace;font-size:9px;letter-spacing:0.14em;text-transform:uppercase;padding:6px 12px;cursor:pointer';
        done.addEventListener('click', function (e) { e.stopPropagation(); active = -1; render(); paintPhotos(); });
        hint.appendChild(span); hint.appendChild(done);
      } else {
        hint.textContent = cfg.state.finishes.length ? 'Click a finish name to choose its photos. Photos not assigned to any finish show in every finish.' : '';
      }
      listEl.appendChild(hint);
    }
    function paintPhotos() {
      var boxes = document.getElementById(cfg.photos).querySelectorAll('.pgx-ph');
      var f = active >= 0 ? cfg.state.finishes[active] : null;
      boxes.forEach(function (box) {
        var old = box.querySelector('.pgx-fin-badge');
        if (old) old.remove();
        box.style.outline = '';
        var src = tileSrc(box);
        if (!src) return;
        // every finish this photo belongs to shows as a small tag, the active one in red
        var owners = cfg.state.finishes.filter(function (x) { return x.picks.has(src); });
        if (f && f.picks.has(src)) box.style.outline = '2px solid #a8221c';
        else if (f) box.style.outline = '2px dashed rgba(17,17,16,0.25)';
        if (owners.length) {
          var b = document.createElement('div');
          b.className = 'pgx-fin-badge';
          b.textContent = owners.map(function (x) { return x.name; }).join(' / ');
          b.style.cssText = 'position:absolute;top:4px;left:4px;right:4px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;background:' + (f && f.picks.has(src) ? '#a8221c' : '#111110') + ';color:#fbfbf9;font-family:\'JetBrains Mono\',monospace;font-size:8px;padding:2px 5px;z-index:4;pointer-events:none';
          box.appendChild(b);
        }
      });
    }
    // clicking a photo while a finish is active toggles it into that finish; the tile itself carries its image link,
    // so dropped photos never shift the mapping
    document.getElementById(cfg.photos).addEventListener('click', function (e) {
      if (active < 0) return;
      var box = e.target.closest ? e.target.closest('.pgx-ph') : null;
      if (!box) return;
      // consume the event so the tile's own keep/drop handler never runs while mapping a finish
      e.stopPropagation();
      e.preventDefault();
      var src = tileSrc(box);
      if (!src) return;
      var f = cfg.state.finishes[active];
      if (box.classList.contains('drop')) {
        // a dropped photo cannot belong to a finish: put it back on the keep pile first
        var im = cfg.getImages().filter(function (i) { return i.src === src; })[0];
        if (im) { im.keep = true; box.classList.remove('drop'); var kk = box.querySelector('.k'); if (kk) kk.textContent = 'keep'; }
      }
      if (f.picks.has(src)) f.picks.delete(src); else f.picks.add(src);
      render(); paintPhotos();
    }, true);
    cfg.dropped = function (src, isDropped) {
      if (!isDropped) return;
      cfg.state.finishes.forEach(function (x) { x.picks.delete(src); });
      render(); paintPhotos();
    };

    addBtn.addEventListener('click', function () {
      var name = (nameInput.value || '').trim();
      if (!name) { nameInput.focus(); return; }
      cfg.state.finishes.push({ name: name, picks: new Set() });
      nameInput.value = '';
      active = cfg.state.finishes.length - 1;
      render(); paintPhotos();
    });
    nameInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); addBtn.click(); } });

    cfg.repaint = function () { active = -1; render(); paintPhotos(); };
    cfg.collect = function () {
      return cfg.state.finishes.map(function (f) {
        return { name: f.name, images: Array.from(f.picks) };
      }).filter(function (f) { return f.name && f.images.length; });
    };
    window[cfg.exportName] = cfg;
    render();
  }
  window.__wmgFinishBuild = build;
})();

/* ---------- after a live publish: watch the shelf and the photo processing ---------- */
(function () {
  function esc5(s){return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];});}
  window.__wmgWatchPublish = function (box, res, apiFn) {
    if (!res || !res.productId) return;
    var line = document.createElement('div');
    line.className = 'pgx-mono';
    line.style.cssText = 'margin-top:10px;font-size:10px;letter-spacing:0.08em;color:#4a4842;line-height:1.7';
    box.appendChild(line);
    var shelfName = ({ wheels: 'Wheels', backshelf: 'Backshelf', 'brand-new': 'Shop Brand New', 'source-import': 'Source / Import', merch: 'Merch' })[res.shelf] || res.shelf || 'its shelf';
    var started = Date.now(), tries = 0;
    function paint(st) {
      var bits = [];
      if (st.inShelf === true) bits.push('\u2713 In the ' + shelfName + ' shelf');
      else if (st.shelfExists === false) bits.push('\u26a0 The ' + shelfName + ' collection does not exist yet: run Store setup');
      else bits.push('\u23f3 Filing into the ' + shelfName + ' shelf (Shopify usually takes a few seconds, sometimes a minute)');
      if (st.mediaTotal) {
        if (st.mediaReady >= st.mediaTotal) bits.push('\u2713 All ' + st.mediaTotal + ' photos processed');
        else bits.push('\u23f3 Photos processing: ' + st.mediaReady + ' of ' + st.mediaTotal + ' ready' + (st.mediaFailed ? ', ' + st.mediaFailed + ' failed' : ''));
      } else bits.push('\u26a0 No photos on the product');
      if (st.published === false) bits.push('\u26a0 Not published to the Online Store channel yet');
      line.innerHTML = bits.map(esc5).join('<br>');
      return st.inShelf === true && st.mediaReady >= st.mediaTotal && st.published !== false;
    }
    function tick() {
      tries++;
      apiFn('status', { productId: res.productId, shelf: res.shelf || '' }).then(function (st) {
        if (!st || !st.ok) { line.textContent = 'Status check: ' + ((st && st.error) || 'no answer'); return; }
        var done = paint(st);
        if (!done && Date.now() - started < 180000) setTimeout(tick, tries < 6 ? 4000 : 8000);
        else if (!done) line.innerHTML += '<br>Still settling. Open the product page in a minute; a hard refresh (Ctrl/Cmd+Shift+R) clears any cached copy of the shelf.';
      }).catch(function (err) { line.textContent = 'Status check failed: ' + err.message; });
    }
    line.textContent = 'Checking the shelf...';
    setTimeout(tick, 1500);
  };
})();



/* ==========================================================================================================
   Shared listing editor pieces (propagator v0.9)
   __wmgSpecs      specifications editor: label and value rows, add, edit, delete
   __wmgSightBox   the sight unseen checkbox
   __wmgAuction    the note shown when a link was an auction: what was left out, for your reference
   __wmgLane       a whole lane (Brand New, Incoming): link in, photos, finishes, description, specs, price, send
   ========================================================================================================== */
(function () {
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function el(tag, attrs, html) { var e = document.createElement(tag); Object.keys(attrs || {}).forEach(function (k) { if (k === 'style') e.style.cssText = attrs[k]; else e.setAttribute(k, attrs[k]); }); if (html != null) e.innerHTML = html; return e; }

  /* ---------- specifications editor ---------- */
  function specs(container, initial) {
    var rows = [];
    var wrap = el('div', { class: 'pgx-field pgx-specs' });
    wrap.innerHTML = '<label class="pgx-label">Specifications <span style="text-transform:none;letter-spacing:0">(shown as a table on the item page; edit, add or remove freely)</span></label>';
    var list = el('div', { class: 'pgx-spec-list' });
    var add = el('button', { type: 'button', class: 'pgx-btn ghost pgx-spec-add', style: 'padding:9px 14px;margin-top:8px' }, 'Add a row');
    wrap.appendChild(list); wrap.appendChild(add);
    container.appendChild(wrap);
    function row(k, v) {
      var r = el('div', { class: 'pgx-spec-row' });
      var ki = el('input', { type: 'text', class: 'pgx-spec-k', placeholder: 'Label, like Material' }); ki.value = k || '';
      var vi = el('input', { type: 'text', class: 'pgx-spec-v', placeholder: 'Value, like FRP' }); vi.value = v || '';
      var del = el('button', { type: 'button', class: 'pgx-spec-del', title: 'Remove this row' }, '\u00d7');
      del.addEventListener('click', function () { r.remove(); rows = rows.filter(function (x) { return x !== r; }); if (api.onChange) api.onChange(); });
      [ki, vi].forEach(function (i) { i.addEventListener('input', function () { if (api.onChange) api.onChange(); }); });
      r.appendChild(ki); r.appendChild(vi); r.appendChild(del);
      list.appendChild(r); rows.push(r);
      return r;
    }
    add.addEventListener('click', function () { row('', '').querySelector('input').focus(); });
    var api = {
      set: function (obj) { list.innerHTML = ''; rows = []; Object.keys(obj || {}).forEach(function (k) { row(k, obj[k]); }); if (!rows.length) row('', ''); },
      get: function () { var o = {}; rows.forEach(function (r) { var k = r.querySelector('.pgx-spec-k').value.trim(), v = r.querySelector('.pgx-spec-v').value.trim(); if (k && v) o[k] = v; }); return o; },
      el: wrap, onChange: null
    };
    api.set(initial || {});
    return api;
  }

  /* ---------- sight unseen ---------- */
  function sightBox(container) {
    var w = el('label', { class: 'pgx-check pgx-sight' });
    w.innerHTML = '<input type="checkbox"> <span><b>Sight unseen</b> puts a disclaimer on the item page: bought on the seller\u2019s photos and description, not inspected by us.</span>';
    container.appendChild(w);
    var box = w.querySelector('input');
    return { get: function () { return !!box.checked; }, set: function (v) { box.checked = !!v; }, el: w, input: box };
  }

  /* ---------- auction note ---------- */
  function auctionNote(target, a) {
    target.innerHTML = '';
    if (!a) return;
    var yen = function (n) { return n ? '\u00a5' + Number(n).toLocaleString('en-US') : ''; };
    var bits = [];
    if (a.currentPrice) bits.push('current bid ' + yen(a.currentPrice));
    if (a.startPrice) bits.push('started at ' + yen(a.startPrice));
    if (a.buyoutPrice) bits.push('buyout ' + yen(a.buyoutPrice));
    if (a.bids != null) bits.push(a.bids + ' bids');
    if (a.ends) bits.push('ends ' + String(a.ends).replace('T', ' ').slice(0, 16));
    var n = el('div', { class: 'pgx-auction' });
    n.innerHTML = '<b>Auction listing.</b> For your reference only, none of this goes on the store: ' + esc(bits.join(', ') || 'no auction figures found') + '. Set your own price below.';
    target.appendChild(n);
  }

  /* ---------- a whole lane ---------- */
  function lane(root, cfg) {
    if (!root) return null;
    var S = { product: null, images: [], finishes: [], type: cfg.types[0].value, busy: false };
    var id = function (k) { return cfg.key + '-' + k; };
    var $ = function (k) { return document.getElementById(id(k)); };
    var typeRadios = cfg.types.length > 1
      ? '<div class="pgx-modes" id="' + id('types') + '">' + cfg.types.map(function (t, i) {
          return '<label data-mode="' + t.value + '"' + (i === 0 ? ' class="sel"' : '') + '><input type="radio" name="' + id('type') + '" value="' + t.value + '"' + (i === 0 ? ' checked' : '') + '><div class="t"><b>' + esc(t.label) + '</b><span>' + esc(t.hint) + '</span></div></label>';
        }).join('') + '</div>'
      : '';
    root.innerHTML =
      '<div class="pgx-head"><span class="pgx-num">' + esc(cfg.num) + '</span><h2>' + esc(cfg.title) + '</h2></div>' +
      '<div class="pgx-body">' +
        '<p class="pgx-p">' + cfg.intro + '</p>' +
        '<div class="pgx-field"><label class="pgx-label" for="' + id('url') + '">Listing link</label><input type="text" id="' + id('url') + '" placeholder="https://... (Yahoo Auctions, Buyee and ZenMarket links work too)"></div>' +
        '<button class="pgx-btn" id="' + id('fetch') + '" type="button">Fetch the listing</button> <span class="pgx-status" id="' + id('st') + '"></span>' +
        '<div id="' + id('auction') + '"></div>' +
        '<div class="pgx-hide" id="' + id('editor') + '" style="margin-top:18px">' +
          '<hr class="pgx-hr">' + typeRadios +
          '<div class="pgx-grid">' +
            '<div class="pgx-field" style="grid-column:1/-1"><label class="pgx-label" for="' + id('title') + '">Title</label><input type="text" id="' + id('title') + '"></div>' +
            '<div class="pgx-field"><label class="pgx-label" for="' + id('brand') + '">Make or brand</label><input type="text" id="' + id('brand') + '"></div>' +
            '<div class="pgx-field"><label class="pgx-label" for="' + id('ptype') + '">Product type (optional)</label><input type="text" id="' + id('ptype') + '" placeholder="Aero, Intake, Seats"></div>' +
            '<div class="pgx-field"><label class="pgx-label" for="' + id('price') + '">Price (store currency)</label><input type="number" id="' + id('price') + '" step="1" min="0"></div>' +
            cfg.extraFields.map(function (f) {
              return '<div class="pgx-field" data-for="' + (f.types || []).join(' ') + '"><label class="pgx-label" for="' + id(f.key) + '">' + esc(f.label) + '</label><input type="' + (f.type || 'text') + '" id="' + id(f.key) + '" placeholder="' + esc(f.placeholder || '') + '"' + (f.value ? ' value="' + esc(f.value) + '"' : '') + (f.type === 'number' ? ' min="0" step="1"' : '') + '></div>';
            }).join('') +
          '</div>' +
          '<div class="pgx-field"><label class="pgx-label">Photos <span id="' + id('imgcount') + '"></span></label><p class="pgx-p" style="margin-bottom:10px">Click a photo to keep or drop it.</p><div class="pgx-photos" id="' + id('photos') + '"></div></div>' +
          '<div class="pgx-field"><label class="pgx-label">Finishes and versions <span style="text-transform:none;letter-spacing:0">(optional)</span></label><p class="pgx-p" style="margin-bottom:10px">Add a finish, then click the photos that belong to it. Buyers see only that finish\u2019s photos when they pick it.</p>' +
            '<div id="' + id('finishlist') + '"></div><div style="display:flex;gap:8px;margin-top:10px"><input type="text" id="' + id('finishname') + '" placeholder="Finish name, like Carbon" style="flex:1"><button class="pgx-btn ghost" id="' + id('finishadd') + '" type="button" style="padding:10px 16px">Add finish</button></div></div>' +
          '<div class="pgx-field"><label class="pgx-label" for="' + id('desc') + '">Description</label><textarea id="' + id('desc') + '" style="min-height:130px"></textarea></div>' +
          '<div id="' + id('specs') + '"></div>' +
          '<div id="' + id('sight') + '"></div>' +
          '<div id="' + id('pages') + '"></div>' +
          '<div class="pgx-pvbox"><div class="pgx-label" style="margin-bottom:10px">Preview</div><div id="' + id('pv') + '"></div></div>' +
          '<button class="pgx-btn" id="' + id('send') + '" type="button" style="margin-top:14px"></button> <span class="pgx-status" id="' + id('send-st') + '"></span>' +
          '<div id="' + id('out') + '"></div>' +
        '</div>' +
      '</div>';

    var specEd = specs($('specs'), {});
    var sight = sightBox($('sight'));
    var pagePick = pages($('pages'), cfg.home || '');
    specEd.onChange = paint;
    sight.input.addEventListener('change', paint);
    ['title', 'brand', 'price', 'desc'].concat(cfg.extraFields.map(function (f) { return f.key; })).forEach(function (k) { var e = $(k); if (e) e.addEventListener('input', paint); });

    function status(msg, cls) { var e = $('st'); e.textContent = msg || ''; e.className = 'pgx-status' + (cls ? ' ' + cls : ''); }
    function kept() { return S.images.filter(function (i) { return i.keep; }).map(function (i) { return i.src; }); }
    function showFor() {
      root.querySelectorAll('[data-for]').forEach(function (f) { var list = f.getAttribute('data-for'); f.style.display = !list || list.split(' ').indexOf(S.type) >= 0 ? '' : 'none'; });
      root.querySelectorAll('#' + id('types') + ' label').forEach(function (l) { l.classList.toggle('sel', l.getAttribute('data-mode') === S.type); });
    }
    root.addEventListener('change', function (e) { if (e.target && e.target.name === id('type')) { S.type = e.target.value; var t = cfg.types.filter(function (x) { return x.value === S.type; })[0]; if (t && t.defaults) Object.keys(t.defaults).forEach(function (k) { var inp = $(k); if (inp && !inp.value) inp.value = t.defaults[k]; }); showFor(); paint(); paintSend(); } });

    function renderPhotos() {
      var box = $('photos'); box.innerHTML = '';
      $('imgcount').textContent = S.images.length ? '(' + S.images.length + ' found)' : '(none found)';
      if (!S.images.length) { box.innerHTML = '<div class="pgx-empty">No photos were found on that page. Add them in Shopify admin after sending.</div>'; return; }
      S.images.forEach(function (im) {
        var d = el('div', { class: 'pgx-ph' + (im.keep ? '' : ' drop'), 'data-src': im.src });
        var img = el('img'); img.src = im.src; img.loading = 'lazy'; img.referrerPolicy = 'no-referrer';
        img.onerror = function () { d.classList.add('blocked'); img.style.display = 'none'; };
        var k = el('div', { class: 'k' }, im.keep ? 'keep' : 'dropped');
        d.appendChild(img); d.appendChild(k);
        d.addEventListener('click', function () { im.keep = !im.keep; d.classList.toggle('drop', !im.keep); k.textContent = im.keep ? 'keep' : 'dropped'; if (S._fin && S._fin.dropped) S._fin.dropped(im.src, !im.keep); paint(); });
        box.appendChild(d);
      });
    }

    function paint() {
      var pv = $('pv'); if (!pv || !S.product) return;
      var imgs = kept();
      var fins = S._fin && S._fin.collect ? S._fin.collect() : [];
      var active = S._pvFinish || '';
      var shown = active ? (fins.filter(function (f) { return f.name === active; })[0] || { images: imgs }).images : imgs;
      var t = cfg.types.filter(function (x) { return x.value === S.type; })[0] || cfg.types[0];
      var price = $('price').value;
      var sp = specEd.get();
      var desc = $('desc').value.trim();
      var lead = $('lead') && $('lead').value.trim();
      var eta = $('eta') && $('eta').value.trim();
      pv.innerHTML =
        '<div class="pgx-pv-grid"><div><div class="pgx-pv-hero">' + (shown[0] ? '<img src="' + esc(shown[0]) + '" referrerpolicy="no-referrer">' : '<div class="ph">No photo</div>') + '</div>' +
          (shown.length > 1 ? '<div class="pgx-pv-thumbs">' + shown.slice(1, 5).map(function (u) { return '<div><img src="' + esc(u) + '" referrerpolicy="no-referrer"></div>'; }).join('') + '</div>' : '') + '</div>' +
        '<div><div class="pgx-pv-eyebrow">' + esc(t.eyebrow) + '</div><h4 class="pgx-pv-title">' + esc($('title').value || 'Untitled') + '</h4>' +
          '<div class="pgx-pv-sub">' + esc($('brand').value || 'Wont Miss Garage') + '</div>' +
          '<div class="pgx-pv-price"><b>' + (price ? '$' + esc(price) : (t.noPrice || 'Set a price')) + '</b></div>' +
          (fins.length ? '<div class="pgx-pv-fins">' + fins.map(function (f) { return '<span data-fin="' + esc(f.name) + '" class="' + (f.name === active ? 'on' : '') + '">' + esc(f.name) + ' \u00b7 ' + f.images.length + '</span>'; }).join('') + '</div>' : '') +
          (lead && S.type === 'made' ? '<div class="pgx-pv-note">Made to order \u00b7 ' + esc(lead) + '</div>' : '') +
          (eta && cfg.key === 'pgi' ? '<div class="pgx-pv-note">Expected \u00b7 ' + esc(eta) + '</div>' : '') +
          (sight.get() ? '<div class="pgx-pv-note warn">Sight unseen disclaimer shown on the item page</div>' : '') +
          '<span class="pgx-pv-btn">' + esc(price || !t.noPrice ? t.button : t.noPriceButton || t.button) + '</span>' +
          (Object.keys(sp).length ? '<table>' + Object.keys(sp).slice(0, 10).map(function (k) { return '<tr><th>' + esc(k) + '</th><td>' + esc(sp[k]) + '</td></tr>'; }).join('') + '</table>' : '') +
          (desc ? '<div class="pgx-pv-desc">' + esc(desc) + '</div>' : '') +
        '</div></div>';
      pv.querySelectorAll('[data-fin]').forEach(function (s) { s.addEventListener('click', function () { var n = s.getAttribute('data-fin'); S._pvFinish = S._pvFinish === n ? '' : n; paint(); }); });
    }
    function paintSend() {
      var dry = !!(window.__wmgHealth && window.__wmgHealth.dryRun !== false);
      var t = cfg.types.filter(function (x) { return x.value === S.type; })[0] || cfg.types[0];
      $('send').textContent = dry ? 'Run test send (creates nothing)' : t.send;
    }

    $('fetch').addEventListener('click', function () {
      var url = $('url').value.trim();
      if (!url) { status('Paste a link first.', 'bad'); return; }
      var btn = $('fetch'); btn.disabled = true; btn.textContent = 'Reading the page\u2026';
      status('');
      cfg.api('import', { url: url }).then(function (res) {
        if (!res || !res.success) throw new Error((res && res.error) || 'Could not read that page.');
        var p = res.product || {};
        S.product = p;
        S.images = (p.images || []).filter(function (s) { return /^https:\/\//i.test(String(s || '')); }).map(function (s) { return { src: String(s).trim(), keep: true }; });
        $('title').value = p.title || ''; $('brand').value = p.manufacturer || ''; $('ptype').value = p.category || '';
        $('price').value = res.suggested && res.suggested.price ? res.suggested.price : '';
        $('desc').value = p.description || '';
        specEd.set(p.specifications || {});
        sight.set(false);
        auctionNote($('auction'), res.auction);
        renderPhotos();
        if (!S._fin) {
          S._fin = { addBtn: id('finishadd'), nameInput: id('finishname'), list: id('finishlist'), photos: id('photos'), getImages: function () { return S.images; }, state: S, exportName: '_wmgFin_' + cfg.key, onChange: paint };
          if (window.__wmgFinishBuild) window.__wmgFinishBuild(S._fin);
        } else if (S._fin.repaint) { S.finishes = []; S._fin.repaint(); }
        $('editor').classList.remove('pgx-hide');
        showFor(); paint(); paintSend();
        var warn = (res.warnings || []).join(' ');
        status((S.images.length ? S.images.length + ' photos' : 'No photos') + ' pulled.' + (warn ? ' ' + warn : ''), 'ok');
      }).catch(function (err) { if (err.message !== 'bad passcode') status(err.message, 'bad'); })
        .then(function () { btn.disabled = false; btn.textContent = 'Fetch the listing'; });
    });

    function collect() {
      var t = S.type;
      var product = Object.assign({}, S.product || {}, {
        title: $('title').value.trim(), manufacturer: $('brand').value.trim(), description: $('desc').value,
        images: kept(), specifications: specEd.get()
      });
      var priceVal = $('price').value.trim();
      var options = { mode: cfg.mode || t, incomingKind: cfg.mode ? t : undefined, pages: pagePick.get(), price: priceVal === '' ? null : Number(priceVal), productType: $('ptype').value.trim() || cfg.productType || null, sightUnseen: sight.get(),
        finishes: S._fin && S._fin.collect ? S._fin.collect() : [], testProduct: false };
      cfg.extraFields.forEach(function (f) {
        if (f.types && f.types.indexOf(t) < 0) return;
        var v = ($(f.key).value || '').trim();
        if (v === '') return;
        options[f.opt || f.key] = f.type === 'number' ? Number(v) : v;
      });
      return { product: product, options: options };
    }

    $('send').addEventListener('click', function () {
      if (!S.product || S.busy) return;
      var c = collect();
      var t = cfg.types.filter(function (x) { return x.value === S.type; })[0] || cfg.types[0];
      if (!c.product.title) { status('The item needs a title.', 'bad'); return; }
      if (t.priceRequired && !(c.options.price > 0)) { $('send-st').textContent = 'Set a price first: ' + t.label + ' items are bought through checkout.'; $('price').focus(); return; }
      if (t.leadRequired && !c.options.leadTime) { $('send-st').textContent = 'Set the lead time buyers will see.'; $('lead').focus(); return; }
      S.busy = true;
      var btn = $('send'); btn.disabled = true; btn.textContent = 'Sending\u2026'; $('send-st').textContent = '';
      cfg.api('publish', c).then(function (res) {
        var box = el('div');
        if (res && res.ok && res.dryRun) {
          box.className = 'pgx-result dry';
          box.innerHTML = '<h3>Test passed, nothing was created</h3><div>DRY_RUN is on in the sheet. Set it to 0 and send again to add it for real.</div>';
        } else if (res && res.ok) {
          box.className = 'pgx-result good';
          box.innerHTML = '<h3>' + esc(t.done) + '</h3><div style="margin-top:6px"><a href="' + esc((res.storefrontUrl || '#') + (res.storefrontUrl ? '?wmg_preview=1' : '')) + '" target="_blank" rel="noopener">Open the item page</a> &nbsp;&middot;&nbsp; <a href="' + esc(res.adminUrl || '#') + '" target="_blank" rel="noopener">Open in Shopify admin</a></div>' +
            (res.warnings && res.warnings.length ? '<div style="margin-top:10px">' + res.warnings.map(esc).join('<br>') + '</div>' : '');
          if (window.__wmgWatchPublish) window.__wmgWatchPublish(box, res, cfg.api);
        } else {
          box.className = 'pgx-result bad';
          box.innerHTML = '<h3>That did not go through</h3><div>' + esc((res && res.error) || 'Unknown error') + '</div>';
        }
        $('out').innerHTML = ''; $('out').appendChild(box);
      }).catch(function (err) { if (err.message !== 'bad passcode') $('send-st').textContent = err.message; })
        .then(function () { S.busy = false; btn.disabled = false; paintSend(); });
    });
    return { state: S, collect: collect, paint: paint };
  }

  /* ---------- "also appear in" ---------- */
  var PAGES = [
    { key: 'incoming', label: 'Incoming inventory' }, { key: 'brand-new', label: 'Shop Brand New' }, { key: 'wheels', label: 'Wheels' },
    { key: 'backshelf', label: 'Backshelf' }, { key: 'importing', label: 'Importing' }, { key: 'merch', label: 'Merch' }
  ];
  function pages(container, home, compact) {
    var w = el('div', { class: 'pgx-field pgx-pages' + (compact ? ' compact' : '') });
    w.innerHTML = compact ? '' : '<label class="pgx-label">Also appear in <span style="text-transform:none;letter-spacing:0">(its own page is always ticked)</span></label>';
    var row = el('div', { class: 'pgx-page-row' });
    w.appendChild(row);
    container.appendChild(w);
    var H = home || '';
    function paint(selected) {
      row.innerHTML = '';
      PAGES.forEach(function (pg) {
        var own = pg.key === H;
        var lab = el('label', { class: 'pgx-page' + (own ? ' own' : ''), 'data-page': pg.key });
        lab.innerHTML = '<input type="checkbox"' + (own || selected.indexOf(pg.key) >= 0 ? ' checked' : '') + (own ? ' disabled' : '') + '> ' + esc(pg.label) + (own ? ' <span>its page</span>' : '');
        row.appendChild(lab);
      });
    }
    paint([]);
    return {
      get: function () { return [].slice.call(row.querySelectorAll('.pgx-page')).filter(function (l) { return !l.classList.contains('own') && l.querySelector('input').checked; }).map(function (l) { return l.getAttribute('data-page'); }); },
      set: function (sel) { paint(sel || []); },
      home: function (h) { var sel = this.get(); H = h || ''; paint(sel.filter(function (x) { return x !== H; })); },
      el: w
    };
  }
  window.__wmgPages = pages;
  window.__wmgSpecs = specs;
  window.__wmgSightBox = sightBox;
  window.__wmgAuction = auctionNote;
  window.__wmgLane = lane;
})();

/* ---------- the Brand New and Incoming lanes ---------- */
(function () {
  function api(action, body) { return window.__wmgApi(action, body); }
  window.__wmgLane(document.getElementById('pgi-root'), {
    key: 'pgi', num: 'Incoming inventory', title: 'Add to Incoming inventory', api: api, productType: null, mode: 'incoming', home: 'incoming',
    intro: 'Everything here is not in the US yet. Pick <b>New</b>, <b>Used</b> or <b>Made to order</b>; the Incoming inventory page shows each in its own section. With a price, buyers can check out right away or reserve it; without one, it is reserve only. Made to order items also take special requests at checkout. Tick <b>Also appear in</b> at the bottom to show it on other pages too, like Shop Brand New.',
    types: [
      { value: 'new', label: 'New', hint: 'Brand new, on its way from the maker or seller.', eyebrow: 'Incoming / New', button: 'Add to cart', noPrice: 'Reserve only', noPriceButton: 'Reserve this part', send: 'Add to Incoming inventory', done: 'On the Incoming inventory page, under New' },
      { value: 'used', label: 'Used', hint: 'Bought used, on its way.', eyebrow: 'Incoming / Used', button: 'Add to cart', noPrice: 'Reserve only', noPriceButton: 'Reserve this part', send: 'Add to Incoming inventory', done: 'On the Incoming inventory page, under Used' },
      { value: 'made', label: 'Made to order', hint: 'Being built. Lead time shown, special requests welcome.', eyebrow: 'Incoming / Made to order', button: 'Add to cart', noPrice: 'Reserve only', noPriceButton: 'Reserve this part', send: 'Add to Incoming inventory', done: 'On the Incoming inventory page, under Made to order', leadRequired: true, defaults: { lead: '8 to 12 weeks' } }
    ],
    extraFields: [
      { key: 'eta', label: 'Expected arrival (optional)', placeholder: 'Late October, or On the water' },
      { key: 'lead', opt: 'leadTime', label: 'Lead time shown to buyers', placeholder: 'e.g. 8 to 12 weeks', types: ['made'] }
    ]
  });
})();
